import { computed, onBeforeUnmount, onMounted, ref } from "vue";

/**
 * Tracks viewport width and exposes an `isMobile` flag.
 * Defaults to the < 1024px breakpoint used across the home sliders.
 */
export function useIsMobile(breakpoint = 1024) {
  const windowWidth = ref<number>(0);

  const handleResize = () => {
    windowWidth.value = window.innerWidth;
  };

  onMounted(() => {
    windowWidth.value = window.innerWidth;
    window.addEventListener("resize", handleResize);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", handleResize);
  });

  const isMobile = computed(() => windowWidth.value < breakpoint);

  return { windowWidth, isMobile };
}
